import createPlugin from './createPlugin'

import ProductsRenderer from './Renderer/ProductsRenderer'

const productsPlugin = settings =>
    createPlugin({
        Renderer: ProductsRenderer,
        ...settings,
    })

const products = productsPlugin()
export default products

export { productsPlugin, ProductsRenderer }
